import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Subject} from 'rxjs';

import {environment} from '../../../../environments/environment';
import * as moment from 'moment';
import { catchError, shareReplay } from 'rxjs/operators';
import { CustomAlertService } from 'src/app/_components/custom-alert/custom-alert.service';

const API_URL = environment.apiUrl;

@Injectable()
export class AsistenciaService {

  private tiposAusencia = [
    {id: -1, label: 'Seleccione', nickName: 'Sel'},
    {id: 0, label: 'Ausencias o retardos que no cuentan', nickName: 'NC'},
    {id: 1, label: 'Ausencias o retardos justificados por asuntos personales', nickName: 'PJ'},
    {id: 2, label: 'Ausencias o retardos justificados por actividades del colegio', nickName: 'CJ'},
    {id: 3, label: 'Ausencias o retardos no justificados', nickName: 'NJ'}
  ];

  tiposAsistencia$ = this.http.get(`${API_URL}/api/asistencia/tipos`).pipe(shareReplay(1));

  private subject = new Subject<any>();
  private subjectCambios = new Subject<any>();
  cambios$ = this.subjectCambios.asObservable();

  constructor(private http: HttpClient, private customAlert: CustomAlertService) {
  }

  getTipoAusencias() {
    return this.tiposAusencia;
  }

  getAsistenciaCurso(mcpID, fecha = '') {
    return this.http.get<any>(`${API_URL}/api/Asistencia/alumnos/materia/${mcpID}${fecha === '' ? '' : '/fecha/' + fecha}`);
  }

  getAsistenciaDia(mcpIds, fecha = '') {
    let model;
    if (mcpIds === '') {
      model = {
        fecha
      };
    } else {
      model = {
        ids: mcpIds,
        fecha
      };
    }
    return this.http.post<any[]>(`${API_URL}/api/Asistencia/materias/fecha`, model).pipe(
      catchError(err => {
        this.handleError(err);
        return [];
      })
    );
  }

  getListaAlumnosReporte(fecha = '') {
    const url = fecha === '' ? `${API_URL}/api/asistencia/reporte` : `${API_URL}/api/asistencia/reporte/fecha/${fecha}`;
    return this.http.get(url);
  }

  getListaAlumnos(fecha = '') {
    const url = fecha === '' ? `${API_URL}/api/asistencia/alumnos` : `${API_URL}/api/asistencia/alumnos/fecha/${fecha}`;
    return this.http.get(url);
  }

  getAcumuladoCurso(cursoID, periodoID = 0) {
    return this.http.get(`${API_URL}/api/asistencia/acumulada/curso/${cursoID}${+periodoID === 0 ? '' : '/periodo/' + periodoID}`);
  }

  getDetailAcumulada(alumnoID, materiaID, periodoID = 0) {
    const url = `${API_URL}/api/Asistencia/acumulada/detalle/alumno/${alumnoID}/materia/${materiaID}
      ${periodoID > 0 ? '/periodo/' + periodoID : ''}`;
    return this.http.get(url);
  }

  setDetailAcumuladaHTML(data, tipDiv) {
    const tipoControl = ['', '0', '1', '2', '3'],
      letraControl = ['A', 'R', 'AR'];
    const contentDiv = tipDiv.append('div');

    let htmlContenido = '';
    tipoControl.map(tipoControlI => {
      htmlContenido += '<div class="flex-wrap">';
      letraControl.map((letraI, i) => {
        const currData = data.find(dataI => dataI.codigo === (letraI + tipoControlI)),
          qtyControl = i === 1 ? 'retardos' : 'numerico';
        let fechas = '';
        if (i < 2 && currData.fechas.length > 0) {
          fechas += '<ul class="detail-list">';
          currData.fechas.map(fechaI => {
            fechas += `<li><small style="color: gray;">${fechaI}</small></li>`;
          });
          fechas += '</ul>';
        }

        htmlContenido += `<div class="inline-flex">
              <div>
                <div class="flex-wrap full-width" style="align-items: flex-end;">
                  ${i < 2 ? letraI + tipoControlI + ':' : ''} ${currData[qtyControl]}
                  ${i === 2 ? '<small style="color: gray;">&nbsp;(' + currData.porcentaje + ')%</small>' : ''}
                </div>
                <div class="full-width">
                  ${fechas}
                </div>
              </div>
            </div>`;
      });
      htmlContenido += '</div>';
    });

    contentDiv.html(htmlContenido);
  }

  getDetailTareasAcumuladas(alumnoID, materiaID, periodoID = 0) {
    const url = `${API_URL}/api/Asistencia/acumulada/detalle/tarea/alumno/${alumnoID}/materia/${materiaID}
      ${periodoID > 0 ? '/periodo/' + periodoID : ''}`;
    return this.http.get(url);
  }

  setTareasDetailHTML(data, detailDiv) {
    const ul = detailDiv.append('ul');

    ul.selectAll('li')
      .data(data.fechasComentario).enter()
      .append('li')
      .attr('class', 'flex-wrap')
      .html(d => `<div class="inline-flex">${d.item1}</div><div class="inline-flex" style="white-space: pre-wrap;">${d.item2}</div>`);
  }

  getDetailMateria(materiaID, periodoID) {
    return this.http.get(`${API_URL}/api/Asistencia/acumulada/detalle/materia/${materiaID}/periodo/${periodoID}`);
  }

  getDetailCurso(cursoID, periodoID) {
    return this.http.get(`${API_URL}/api/Asistencia/acumulada/detalle/curso/${cursoID}/periodo/${periodoID}`);
  }

  getAcumuladoDirAcademica(periodoID) {
    return this.http.get(`${API_URL}/api/Asistencia/acumulada/materias/periodo/${periodoID}`);
  }

  getReporteAcumuladoCurso(periodoID) {
    return this.http.get(`${API_URL}/api/Asistencia/acumulada/cursos/periodo/${periodoID}`);
  }

  getReporteAcumuladoAlertas(periodoID) {
    return this.http.get(`${API_URL}/api/Asistencia/acumulada/alerta/periodo/${periodoID}`);
  }

  setEstadoAsistencia(objeto, fecha = '') {
    const metodo = +objeto.id === 0 ? 'post' : 'put';
    return this.http[metodo](`${API_URL}/api/asistencia/general`, objeto);
  }

  setEstadoAsistenciaMateria(objeto, fecha = '') {
    const metodo = +objeto.id === 0 ? 'post' : 'put';
    return this.http[metodo](`${API_URL}/api/asistencia/alumno/materia`, objeto);
  }

  deleteAsistenciaAlumno(idRegistro) {
    return this.http.delete(`${API_URL}/api/asistencia/alumno/borrar/${idRegistro}`);
  }

  getTiposAsistencia() {
    return this.http.get(`${API_URL}/api/asistencia/tipos`);
  }

  setTarea(obj) {
    const accion = obj.id === 0 ? 'post' : 'put';
    return this.http[accion](`${API_URL}/api/Asistencia/alumno/tarea/materia`, obj);
  }

  updateMCP(mcp) {
    const action = +mcp.id === 0 ? 'post' : 'put';
    return this.http[action](`${API_URL}/api/asistencia/materia`, mcp);
  }

  getListPendientes(materiaID = 0) {
    const url = +materiaID === 0 ? `${API_URL}/api/Asistencia/pendiente` : `${API_URL}/api/Asistencia/pendiente/materia/${materiaID}`;
    return this.http.get(url);
  }

  signalToUpdateMCPList(mcpID, fecha = '') {
    return this.http.get(`${API_URL}/api/asistencia/actualizar/alumnos/materia/${mcpID}${fecha.length > 0 ? `/fecha/${fecha}` : ''}`);
  }

  toggleSidebar(state) {
    this.subject.next({event: 'toggle-sidebar', state});
  }

  updateFaltaTarea(obj) {
    const accion = obj.id === 0 ? 'post' : 'put';
    return this.http[accion](`${API_URL}/api/Asistencia/alumno/tarea/materia`, obj);
  }

  getObservable() {
    return this.subject.asObservable();
  }

  notificarMateriasSinAsistencia(arg0: any[], value: any, fecha) {
    const model = {
      detalle: value,
      tipoOrigen: 35,
      materias: arg0.map(item => {
        return {id: item.materiaCursoPeriodoID};
      }),
      fecha
    };
    return this.http.post(`${API_URL}/api/Asistencia/notificar/materia`, model);
  }

  emitCambio(object, status) {
    this.subjectCambios.next({object, status});
  }

  public extractData(res: any) {
    const body = res.hasOwnProperty('items') ? res.items : res;
    return body || {};
  }

  handleError(error) {
    this.customAlert.setCustomMessage({
      tipo: 'error',
      texto: `Error en el pedido. ${error.error}.<br> Codigo de error: ${error.statusText}`
    });
  }
}
